
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UIIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
})
